import { useState, useEffect } from "react";
import myImage from "assets/TechTutzLogo.png";

const SpinningImage = ({
  size = 200,
  rotationSpeed = 0.05,
  glowColor = "rgba(0, 255, 255, 0.6)",
  glowSpeed = 2
}) => {
  const [angle, setAngle] = useState(0);
  const [glow, setGlow] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setAngle((prev) => prev + rotationSpeed);
      setGlow((Math.sin(Date.now() / 1000 * (Math.PI / glowSpeed)) + 1) / 2);
    }, 16); // ~60 FPS

    return () => clearInterval(interval);
  }, [rotationSpeed, glowSpeed]);

  return (
    <div
      style={{
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={myImage}
        alt="Spinning Glowing"
        style={{
          width: "100%",
          height: "100%",
          transform: `rotate(${angle}deg)`,
          filter: `drop-shadow(0px 0px ${glow * 10}px ${glowColor})`,
          transition: "transform 0.1s linear",
        }}
      />
    </div>
  );
};

export default SpinningImage;